export default function telField(element, data) {
    const current = element.querySelector(".current");
    const popup = element.querySelector(".popup");
    const isDefault = data.isDefault;
    const cities = data.cities;

    if (isDefault) {
        const options = {
            maximumAge: 3600000,
        };
        
        function success(pos) {
            const crd = pos.coords;

            const foundCity = cities.reduce(function (result, city) {
                const resultDistSqured = result ? Math.pow(result.coord_lat - crd.latitude, 2) + Math.pow(result.coord_lon - crd.longitude, 2) : Number.POSITIVE_INFINITY;
                const cityDistSqured = Math.pow(city.coord_lat - crd.latitude, 2) + Math.pow(city.coord_lon - crd.longitude, 2);
                return cityDistSqured < resultDistSqured ? city : result;
            }, null);

            if (foundCity && !foundCity.is_default) {
                window.location.href = foundCity.url;
            }
        }
        
        function error(err) {
            //console.warn(`ERROR(${err.code}): ${err.message}`);
        }
        
        navigator.geolocation.getCurrentPosition(success, error/*, options*/);
    }      

    current.addEventListener("click", function (event) {
        event.stopPropagation();
        popup.classList.toggle("open");
    });

    window.addEventListener('click', function () {
        popup.classList.remove("open")
    });

};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
